



































































































































































import Component, { mixins } from 'vue-class-component';
import { loadWidget } from '@/utils/helpers';
import { namespace } from 'vuex-class';
import { IUssdHitStats } from '@/types/types';
import { Watch } from 'vue-property-decorator';
import WidgetMixins from '@/mixins/WidgetMixins';
import moment from 'moment';
import qs from 'qs';
import ApexCharts from 'vue-apexcharts';

const ussdModule = namespace('ussdAdmin');

@Component({
  name: 'AnalyticsUssdHits',
  components: {
    InternetConnection: loadWidget('pages/InternetConnection'),
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
    ApexCharts,
  },
  filters: {
    numberFormat: (value: number) => (value ?? 0).toLocaleString(),
  },
})
export default class AnalyticsUssdHits extends mixins(WidgetMixins) {
  @ussdModule.Getter('getHitStats') stats!: IUssdHitStats | null;

  startDate: string = moment()
    .subtract(30, 'days')
    .format('YYYY-MM-DD');
  endDate: string = moment().format('YYYY-MM-DD');
  network: string = 'ALL';
  serviceCode: string = '';
  startMenu: boolean = false;
  endMenu: boolean = false;

  networkHeaders = [
    { text: 'Network', value: 'network' },
    { text: 'Hits', value: 'hits', align: 'end' },
    { text: 'Share', value: 'share', align: 'end' },
  ];
  serviceHeaders = [
    { text: 'Service Code', value: 'serviceCode' },
    { text: 'Short Code', value: 'shortCode' },
    { text: 'Hits', value: 'hits', align: 'end' },
  ];

  chartOptions: any = {
    chart: { toolbar: { show: false }, zoom: { enabled: false }, background: 'transparent' },
    dataLabels: { enabled: false },
    stroke: { curve: 'smooth', width: 2 },
    xaxis: { categories: [] as string[] },
    legend: { position: 'top' },
  };

  get networkOptions(): string[] {
    const known = (this.stats?.byNetwork ?? []).map(row => row.network);
    return ['ALL', ...Array.from(new Set(known))];
  }

  get dailySeries(): any[] {
    return [{ name: 'Hits', data: (this.stats?.daily ?? []).map(row => row.hits) }];
  }

  share(hits: number): string {
    const total = this.stats?.totals.hits ?? 0;
    if (!total) return '0%';
    return `${((hits / total) * 100).toFixed(1)}%`;
  }

  get isDark(): boolean {
    return this.$vuetify.theme.dark;
  }

  @Watch('stats')
  onStatsChange(): void {
    this.chartOptions = {
      ...this.chartOptions,
      xaxis: { categories: (this.stats?.daily ?? []).map(row => row.date) },
    };
  }

  @Watch('isDark', { immediate: true })
  onThemeChange(dark: boolean): void {
    this.chartOptions = {
      ...this.chartOptions,
      theme: { mode: dark ? 'dark' : 'light' },
      tooltip: { theme: dark ? 'dark' : 'light' },
      colors: [dark ? '#FF3D78' : '#FF0055'],
      grid: { borderColor: dark ? 'rgba(255,255,255,0.1)' : '#E4E7EB' },
      chart: { ...this.chartOptions.chart, foreColor: dark ? '#9AA3AE' : '#545D68' },
    };
  }

  @Watch('startDate')
  @Watch('endDate')
  @Watch('network')
  @Watch('serviceCode')
  onFilterChange(): void {
    this.fetchStats();
  }

  fetchStats(): void {
    const query = qs.stringify(
      {
        startDate: this.startDate,
        endDate: this.endDate,
        ...(this.network !== 'ALL' && { network: this.network }),
        ...(this.serviceCode && { serviceCode: this.serviceCode }),
      },
      { skipNulls: true, addQueryPrefix: true },
    );
    this.$store.dispatch('ussdAdmin/fetchHitStats', query);
  }

  created(): void {
    this.fetchStats();
  }
}
